<div class="modal-layer" [ngClass]="{ 'active':modal.open }">
    <div class="backdrop"></div>

    <div class="alert" *ngIf="modal.cntx == 'editing-protocol'">
        <div class="loader">
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
            <div class="obj"></div><div class="obj"></div><div class="obj"></div><div class="obj"></div>
        </div>
        <span class="loader-text">Промяна на протокол...</span>
    </div>
</div>

<div class="content no-subheader">
    <span class="page-title">
        Промяна на протокол ({{ service_num }})
        <span class="right-btn" (click)="EditProtocol()">Запис</span>
        <span routerLink="/fuji-service-presale" class="right-btn negative">Отказ</span>
    </span>

    <div class="tab-holder">
        <div class="tab-headers">
            <div class="tab-header active">Основна информация</div>
        </div>
        <div class="tab-content">
            <div class="tab">
                <div class="category-title">Основна информация</div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Номер на протокол</span>
                    <input type="text" disabled placeholder="Въведете наименование"  [(ngModel)]="editProtocol.service_num" />
                </div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Име на представител на ТЕМПЕКС</span>
                    <input type="text" placeholder="Въведете име на представител"  [(ngModel)]="editProtocol.seller_name" />
                </div>
                <div class="col-xl-3 col-lg-3 input-row">
                    <span class="label">Име на дилър</span>
                    <input type="text" placeholder="Въведете име на търговец"  [(ngModel)]="editProtocol.dealer_name" />
                </div>
                <div class="category-title">Информация за продукт</div>
                <table class="ac_list">
                    <thead>
                        <tr>
                            <th>Модел (Външно тяло)</th>
                            <th>Сериен номер (Външно тяло)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ac of ac_list;let i = index">
                            <td><input (input)="changeAcRow(ac, i)" type="text" [(ngModel)]="ac.model" /></td>
                            <td><input (input)="changeAcRow(ac, i)" type="text" [(ngModel)]="ac.serial" style="width:calc(100% - 60px);" />
                                <div style='float:left;margin-left:10px;margin-top:7.5px;'> <div class='action-remove' *ngIf="ac_list.length > 1" (click)="removeItem(i)"><i class='icon cross'></i></div> </div></td>
                        </tr>
                    </tbody>
                </table>
                <!-- <div class="col-xl-6 col-lg-6 input-row">
                    <span class="label">Модел (Външно тяло)</span>
                    <input type="text" placeholder="Въведете наименование"  [(ngModel)]="addProtocol.model_outdoor" />
                </div>
                <div class="col-xl-6 col-lg-6 input-row">
                    <span class="label">Сериен номер  (Външно тяло)</span>
                    <input type="text" placeholder="Въведете наименование"  [(ngModel)]="addProtocol.serial_outdoor" />
                </div> -->
                <!-- <div class="col-xl-12 col-lg-12 input-row">
                    <span class="label">Описание на дефекта / оплакване</span>
                    <textarea  [(ngModel)]="addProtocol.description"></textarea>
                </div> -->
            </div>
        </div>
    </div>
</div>